/**
 * Generated by orval 🍺
 * Do not edit manually.
 * DGA Control API
 * Sistema de monitoreo de extracción de aguas según Resolución 1238 de la DGA (Dirección General de Aguas).
 *
 * ## Protocol-level errors
 *
 * Answered to a request that is no operation of this spec, so no operation declares them. Their `type` is in `ProblemTypeEnum`.
 *
 * - `405` `/problems/method-not-allowed`: the HTTP verb is not supported on that path.
 * - `404` `/problems/not-found`: the URL matched no route at all. Distinct from an endpoint own 404, which means the route exists and the record does not.
 * OpenAPI spec version: 2.0.0
 */
import {
  HttpClient
} from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpParams
} from '@angular/common/http';

import {
  Injectable,
  inject
} from '@angular/core';

import type {
  Observable
} from 'rxjs';

import type {
  BillingItemCreateRequestV1Request,
  BillingItemResponseV1,
  BillingV1BillingItemsDestroyPathParameters,
  BillingV1BillingItemsListParams,
  BillingV1BillingItemsPartialUpdatePathParameters,
  BillingV1BillingItemsRetrievePathParameters,
  CursorPaginatedBillingItemResponseV1,
  PatchedBillingItemUpdateRequestV1Request
} from '../types';

import type {
  HttpHeaders,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http';



interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
        | HttpParams
      | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue = string | number | boolean | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: boolean | undefined,
  passthroughKeys: ReadonlySet<string>,
): Record<string, unknown>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
  passthroughKeys: ReadonlySet<string> = new Set(),
): Record<string, unknown> {
  const filteredParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (passthroughKeys.has(key)) {
      if (value !== undefined) {
        filteredParams[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      const filtered = value
        .filter(
          (item) =>
            item != null &&
            (typeof item === 'string' ||
              typeof item === 'number' ||
              typeof item === 'boolean' ||
              (item instanceof Date && !Number.isNaN(item.getTime()))),
        )
        .map((item) =>
          item instanceof Date ? item.toISOString() : item,
        ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (value === null && requiredNullableKeys.has(key)) {
      // With a paramsSerializer (preserveRequiredNullables) the literal null
      // is passed through for it to consume; without one, emit an empty
      // string so the required key still reaches the wire as `?key=`
      // instead of being silently dropped. See #3712.
      filteredParams[key] = preserveRequiredNullables ? null : '';
    } else if (value instanceof Date && !Number.isNaN(value.getTime())) {
      // useDates produces Date query params; serialize to ISO so they reach
      // the wire instead of being dropped by the primitive check below. See #3856.
      filteredParams[key] = value.toISOString();
    } else if (
      value != null &&
      (typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean')
    ) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}





@Injectable({ providedIn: 'root' })
export class BillingBillingItemService {
  private readonly http = inject(HttpClient);
/**
 * Admin-only. Returns BillingItem rows ordered by `id`. Defaults to `active=True` only; pass `?active=false` to see soft-retired items. `?category=<x>` filters by category tag (9 values: 5 installation-side + 4 service-side, M-bill-1e).
 * @summary List billing items (cursor-paginated).
 */
 billingV1BillingItemsList<TData = CursorPaginatedBillingItemResponseV1>(params?: BillingV1BillingItemsListParams, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1BillingItemsList<TData = CursorPaginatedBillingItemResponseV1>(params?: BillingV1BillingItemsListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1BillingItemsList<TData = CursorPaginatedBillingItemResponseV1>(params?: BillingV1BillingItemsListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1BillingItemsList<TData = CursorPaginatedBillingItemResponseV1>(
    params?: BillingV1BillingItemsListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/v1/billing/billing_items/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/v1/billing/billing_items/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/v1/billing/billing_items/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
/**
 * Admin-only. New items land `active=True`. Retire via `PATCH active=false`, not DELETE (the latter is refused with 409 if any charge, quote or bundle line references the item).
 * @summary Create a billing item.
 */
 billingV1BillingItemsCreate<TData = BillingItemResponseV1>(billingItemCreateRequestV1Request: BillingItemCreateRequestV1Request, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1BillingItemsCreate<TData = BillingItemResponseV1>(billingItemCreateRequestV1Request: BillingItemCreateRequestV1Request, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1BillingItemsCreate<TData = BillingItemResponseV1>(billingItemCreateRequestV1Request: BillingItemCreateRequestV1Request, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1BillingItemsCreate<TData = BillingItemResponseV1>(
    billingItemCreateRequestV1Request: BillingItemCreateRequestV1Request, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/v1/billing/billing_items/`,
      billingItemCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/v1/billing/billing_items/`,
      billingItemCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/v1/billing/billing_items/`,
      billingItemCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only. Returns the item with its catalog prices (`cost_price`, `profit_pct`, `sale_price`) as they are today, active or retired: a quote line references its item by `billing_item.identity`, and the item may have been retired since.
 * @summary Retrieve one billing item.
 */
 billingV1BillingItemsRetrieve<TData = BillingItemResponseV1>(pathParams: BillingV1BillingItemsRetrievePathParameters, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1BillingItemsRetrieve<TData = BillingItemResponseV1>(pathParams: BillingV1BillingItemsRetrievePathParameters, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1BillingItemsRetrieve<TData = BillingItemResponseV1>(pathParams: BillingV1BillingItemsRetrievePathParameters, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1BillingItemsRetrieve<TData = BillingItemResponseV1>(
    { identity }: BillingV1BillingItemsRetrievePathParameters, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/v1/billing/billing_items/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/v1/billing/billing_items/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/v1/billing/billing_items/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only. Only fields present in the body are written; omitted fields keep their stored value. To soft-retire an item, send `{"active": false}` — the intended alternative to DELETE.
 * @summary Partial-update a billing item (preserve-on-omit).
 */
 billingV1BillingItemsPartialUpdate<TData = BillingItemResponseV1>(pathParams: BillingV1BillingItemsPartialUpdatePathParameters,
    patchedBillingItemUpdateRequestV1Request?: PatchedBillingItemUpdateRequestV1Request, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1BillingItemsPartialUpdate<TData = BillingItemResponseV1>(pathParams: BillingV1BillingItemsPartialUpdatePathParameters,
    patchedBillingItemUpdateRequestV1Request?: PatchedBillingItemUpdateRequestV1Request, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1BillingItemsPartialUpdate<TData = BillingItemResponseV1>(pathParams: BillingV1BillingItemsPartialUpdatePathParameters,
    patchedBillingItemUpdateRequestV1Request?: PatchedBillingItemUpdateRequestV1Request, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1BillingItemsPartialUpdate<TData = BillingItemResponseV1>(
    { identity }: BillingV1BillingItemsPartialUpdatePathParameters,
    patchedBillingItemUpdateRequestV1Request?: PatchedBillingItemUpdateRequestV1Request, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/v1/billing/billing_items/${identity}/`,
      patchedBillingItemUpdateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/v1/billing/billing_items/${identity}/`,
      patchedBillingItemUpdateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/v1/billing/billing_items/${identity}/`,
      patchedBillingItemUpdateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only. Refused with 409 `/problems/billing-item-in-use` if any charge, quote or bundle line references the item — soft-retire via `PATCH active=false` instead. Succeeds with 204 (no body) when the item has zero references.
 * @summary Hard-delete a billing item.
 */
 billingV1BillingItemsDestroy<TData = void>(pathParams: BillingV1BillingItemsDestroyPathParameters, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1BillingItemsDestroy<TData = void>(pathParams: BillingV1BillingItemsDestroyPathParameters, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1BillingItemsDestroy<TData = void>(pathParams: BillingV1BillingItemsDestroyPathParameters, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1BillingItemsDestroy<TData = void>(
    { identity }: BillingV1BillingItemsDestroyPathParameters, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/v1/billing/billing_items/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/v1/billing/billing_items/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/v1/billing/billing_items/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
};

export type BillingV1BillingItemsListClientResult = NonNullable<CursorPaginatedBillingItemResponseV1>
export type BillingV1BillingItemsCreateClientResult = NonNullable<BillingItemResponseV1>
export type BillingV1BillingItemsRetrieveClientResult = NonNullable<BillingItemResponseV1>
export type BillingV1BillingItemsPartialUpdateClientResult = NonNullable<BillingItemResponseV1>
export type BillingV1BillingItemsDestroyClientResult = NonNullable<void>
